module.exports = __webpack_public_path__ + "img/logo1@2x.66c61cf3.png";